import React from 'react';
import { Outlet } from 'react-router-dom';

import Application from '@common/react/components/Core/Application/Application';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';

import AuthWatcher from '@app/components/Auth/AuthWatcher';
import ErrorBoundary from '@app/components/UI/ErrorBoundary/ErrorBoundary';
import ErrorPageContent from '@app/components/UI/ErrorPageContent/ErrorPageContent';

const LayoutWrapper: React.FC = () => {
	return (
		<ErrorBoundary>
			<RequestProvider
				errorComponents={{
					errorPage: ErrorPageContent,
					accessDenied: ErrorPageContent,
				}}
				getErrorComponents={() => null}
			>
				<Application>
					<AuthWatcher />
					<ServerPageProvider
						getIgnoreServerPage={() => true}
						notFoundComponent={<ErrorPageContent />}
						inner={() => <Outlet />}
					/>
				</Application>
			</RequestProvider>
		</ErrorBoundary>
	);
};

export default LayoutWrapper;
